import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/shared/ui/shadcn/ui/select.tsx';
import { useLangSwitcher } from '@/shared/hooks/useLangSwitcher/useLangSwitcher.ts';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/shadcn/utils.ts';

type Props = {
  className?: string;
  chevronClassnames?: string;
};

export const AppLangSwitcher = ({ className, chevronClassnames }: Props) => {
  const { i18n } = useTranslation();
  const { toggle } = useLangSwitcher();
  return (
    <Select onValueChange={toggle} value={i18n.language}>
      <SelectTrigger
        className={cn('border-none', className)}
        chevronClassnames={cn('opacity-100', chevronClassnames)}
        isTransparent
      >
        <SelectValue placeholder="O'zbekcha" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="uz">O'zbekcha</SelectItem>
        <SelectItem value="ru">Русский</SelectItem>
      </SelectContent>
    </Select>
  );
};
